/**
 * @generated SignedSource<<c961dc2f369e00522760f53c82bffb4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_FirstGroupRow_rankField">;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_rankField";
};
export type groupTableBody_nativeIssueTable_rankField$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupTableBody_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "kind": "FragmentSpread",
      "name": "groupRow_issueTableGrouping_FirstGroupRow_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "b66f00058be3f6c30e7828f574c68350";

export default node;
